import { Box, BoxProps, ColorOptions, ModBox, Spacer, Text, TextProps } from '@jfs/ui-new'
import { RootStore } from '../../data/store'

export const PoweredByBanner = () => {
  const { REACT_APP_VERSION } = process.env
  return (
    <Box {...styles.container}>
      <Box flexDirection={'row'}>
        <ExtraDetails title={'SDK Version: '} details={RootStore?.agent?.deviceInfo?.sdkVersion} />
        <ExtraDetails title={'Web Version: '} details={REACT_APP_VERSION} />
      </Box>
      <Box flexDirection={'row'}>
        <Text {...styles.poweredByText}>Powered By</Text>
        <Spacer direction="horizontal" size={4} />
        <Text {...styles.text}>Jio Payments Bank Ltd.</Text>
        <Spacer direction="horizontal" size={4} />
      </Box>
    </Box>
  )
}

const ExtraDetails = ({ title, details }) => {
  return (
    <ModBox pr={8} show={details?.length > 0} flexDirection={'row'} marginVertical={4}>
      <Text {...styles.poweredByText}>{title} </Text>
      <Text {...styles.text}>{details}</Text>
    </ModBox>
  )
}

const styles = {
  container: {
    backgroundColor: 'PRIMARY_ULTRA_LIGHT' as ColorOptions,
    p: 6,
    justifyContent: 'center',
    alignItems: 'center',
  } as BoxProps,
  poweredByText: {
    color: 'PRIMARY_STORNG',
    fontSize: 10,
    fontFamily: 'jioType-medium',
  } as TextProps,
  text: {
    color: 'PRIMARY',
    fontSize: 10,
    fontFamily: 'jioType-bold',
    fontWeight: 'BOLD',
  } as TextProps,
}
